import React from 'react';
export function EngagementPlan() {
  return <div data-id="element-2120">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2121">
        Engagement Plan
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2122">
        Configure your customer engagement strategies and workflows
      </p>

      <div className="space-y-6" data-id="element-2123">
        {/* Engagement Strategy */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2124">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2125">
            Engagement Strategy
          </h2>
          <div className="space-y-4" data-id="element-2126">
            <div data-id="element-2127">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2128">
                Default Follow-up Cadence
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2129">
                <option data-id="element-2130">Immediate (within 1 hour)</option>
                <option data-id="element-2131">Same Day (within 8 hours)</option>
                <option data-id="element-2132">Next Day</option>
                <option data-id="element-2133">Custom</option>
              </select>
            </div>
            <div data-id="element-2134">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2135">
                Maximum Follow-up Attempts
              </label>
              <input type="number" placeholder="3" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2136" />
            </div>
          </div>
        </div>

        {/* Communication Channels */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2137">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2138">
            Preferred Communication Channels
          </h2>
          <div className="space-y-3" data-id="element-2139">
            <label className="flex items-center" data-id="element-2140">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2141" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2142">WhatsApp</span>
            </label>
            <label className="flex items-center" data-id="element-2143">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2144" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2145">Phone Call</span>
            </label>
            <label className="flex items-center" data-id="element-2146">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2147" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2148">Email</span>
            </label>
            <label className="flex items-center" data-id="element-2149">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2150" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2151">SMS</span>
            </label>
          </div>
        </div>

        {/* Auto-Assignment Rules */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2152">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2153">
            Lead Auto-Assignment
          </h2>
          <div className="space-y-4" data-id="element-2154">
            <div data-id="element-2155">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2156">
                Assignment Method
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2157">
                <option data-id="element-2158">Round Robin</option>
                <option data-id="element-2159">Based on Availability</option>
                <option data-id="element-2160">Based on Performance</option>
                <option data-id="element-2161">Manual Assignment</option>
              </select>
            </div>
            <label className="flex items-center" data-id="element-2162">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2163" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2164">
                Automatically assign hot leads to top performers
              </span>
            </label>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2165">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2166">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}